import { applySheets } from "../../../app/utils/styleCache.js";

export class AppToast extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: "open" });
        this.isMounted = false;
        this.timer = null;
        this.message = "";
        this.type = "info";
    }

    connectedCallback() {
        this.shadowRoot.innerHTML = `
            <style>
                :host { opacity: 0; }
                :host([loaded]) { opacity: 1; transition: opacity 0.2s ease-in; }
            </style>
            <div class="toast ${this.type}">
                <div class="toastContent">
                    <div class="toastIcon">${this.getIcon()}</div>
                    <p class="toastText">${this.message}</p>
                    <div class="toastClose"><i class="fa-solid fa-x"></i></div>
                </div>
            </div>
        `;

        this.isMounted = true;

        const closeBtn = this.shadowRoot.querySelector(".toastClose");
        const toastEl  = this.shadowRoot.querySelector(".toast");

        closeBtn.onclick = (e) => {
            e.stopPropagation();
            this.removeToast();
        };

        toastEl.onanimationend = (e) => {
            if (e.animationName === "slideOutRight") this.remove();
        };

        applySheets(this.shadowRoot, [
            "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css",
            "components/layout/app-toast/app-toast.css",
        ]).then(() => requestAnimationFrame(() => {
            this.setAttribute("loaded", "");
            this.timer = setTimeout(() => this.removeToast(), 5000);
        }));
    }

    removeToast() {
        if (this.timer) clearTimeout(this.timer);
        const toastEl = this.shadowRoot.querySelector(".toast");
        if (toastEl && !toastEl.classList.contains("fadeOut")) {
            toastEl.classList.add("fadeOut");
        }
    }

    getIcon() {
        switch(this.type) {
            case 'error':   return '<i class="fa-solid fa-circle-exclamation"></i>';
            case 'warning': return '<i class="fa-solid fa-triangle-exclamation"></i>';
            case 'success': return '<i class="fa-solid fa-circle-check"></i>';
            case 'info':
            default:        return '<i class="fa-solid fa-circle-info"></i>';
        }
    }
}

customElements.define("app-toast", AppToast);
